import { useQuery } from '@tanstack/react-query';
import { ReservedMembersType } from '#types/schedule';
import { fetcher } from '../libs';
import queryKeys from '../queryKeys';

interface Params {
  scheduleId?: string;
}

interface Response
  extends Pick<
    ReservedMembersType,
    | 'title'
    | 'round'
    | 'totalRound'
    | 'taughtAt'
    | 'endedAt'
    | 'personId'
    | 'personName'
    | 'isPersonalSchedule'
    | 'status'
  > {
  registeredLectureId: string;
  coachId: string;
  coachName: string;
}

export default function useScheduleCoachDetailForAdminQuery({
  scheduleId: lectureId
}: Params) {
  return useQuery(
    [queryKeys.SCHEDULE, lectureId, 'admin'],
    () => fetcher<Response>(`/gym-admins/coach-schedule/${lectureId}`),
    {
      enabled: !!lectureId
    }
  );
}
